type Options = { locale?: string; currency?: string };

export const moneyFormatter = (amount: number, options: Options = {}): string => {
	if (!amount) {
		amount = 0;
	}
	const { locale = 'pt-BR', currency = 'BRL' } = options;
	const formattedValue = amount.toLocaleString(locale, { style: 'currency', currency });

	return formattedValue.replace(/(\.|,)00$/g, '');
};
